var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$auth.loading)?_c('v-progress-circular',{staticClass:"d-flex justify-center align-center",attrs:{"indeterminate":"","size":100,"width":10,"color":"secondary"}}):_vm._e(),_c('v-img',{staticStyle:{"height":"94vh"},attrs:{"aspect-ratio":16/9,"src":require("@/assets/main-login.jpg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }